<form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()" id="appointmentForm">
    <div class="grid" *ngIf="calendars.length>0">
        <div class="col-12 md:col-6 xl:col-3 calendarField" >
            <label i18n="@@appointment-management-edit.label.calendar" for="calendar" class="font-medium" id="calendarLabel">Calendar
                *</label>
            <div>
                <p-select id="calendar" inputId="calendar" [options]="calendars" formControlName="calendarId" optionValue="id"
                    optionLabel="title" placeholder="Select calendar" (onChange)="onCalendarChanged($event)"
                    [autoDisplayFirst]="true" [style]="{'max-width':'100%', 'min-width': '100%'}" class="ng-dirty"
                    i18n-placeholder="@@appointment-management-edit.label.select-calendar">
                    <ng-template let-item #item>
                        <div class="white-space-normal" style="word-break: break-word">{{item.title}}</div>
                    </ng-template>
                </p-select>
            </div>
            <div class="errorText"
                *ngIf="appointmentForm.get('calendarId').invalid && (appointmentForm.get('calendarId').dirty || appointmentForm.get('calendarId').touched)">
                <small class="form-text p-error" i18n="@@appointment-management-edit.error.invalid-fieldRequired"
                    *ngIf="appointmentForm.get('calendarId').errors.required" id="CalendarError">Calendar is required</small>
            </div>
        </div>

        <div class="col-12 md:col-6 xl:col-3 titleField">
            <label i18n="@@appointment-management-edit.label.title" for="title" class="font-medium">Titel *</label>
            <input pInputText id="title" type="text" class="inputfield w-full" formControlName="title" autofocus
                aria-describedby="TitleError">
            <div class="errorText"
                *ngIf="appointmentForm.get('title').invalid && (appointmentForm.get('title').dirty || appointmentForm.get('title').touched)">
                <small class="form-text p-error" i18n="@@appointment-management-edit.error.invalid-fieldRequired"
                    *ngIf="appointmentForm.get('title').errors.required" id="TitleError">Title is required</small>
            </div>
        </div>

        <div class="col-12 md:col-6 xl:col-3 categoryField">
            <label i18n="@@appointment-management-edit.label.categories" for="categories" id="categoryLabel"
                class="font-medium">Categories</label>
            <p-multiSelect [options]="categories" optionLabel="title" optionValue="id" formControlName="categoryIds"
                [placeholder]="getCategoryPlaceholder(appointmentForm.get('calendarId').value == null)"
                [disabled]="appointmentForm.get('calendarId').value == null" scrollHeight="250px"
                selectedItemsLabel="{0} Calenders"
                i18n-emptyMessage="@@appointment-management-edit.categories.no-applied"
                emptyMessage="No categories applied" [style]="{'minWidth':'100%'}" id="categories" inputId="categories" [filter]="true"
                ariaLabelledBy="categories" display="chip">

                <ng-template let-values pTemplate="selectedItems">
                    <div class="flex" *ngIf="values && values.length">
                        <ng-container *ngFor="let cat of values">
                            <p-tag [value]="cat.title" [style]="{'background-color':cat.color}"
                                class="mr-2 selectedCategory">
                            </p-tag>
                        </ng-container>
                    </div>
                    <!--                        @if((!values || values.length==0) && appointmentForm.get('calendarId').value != null){-->
                    <!--                            <div>-->
                    <!--                                <div i18n="@@appointment-management-edit.select-category" class="noCategorySelected">Select categories</div>-->
                    <!--                            </div>-->
                    <!--                        } @else if(appointmentForm.get('calendarId').value == null){-->
                    <!--                            <div>-->
                    <!--                                <div i18n="@@appointment-management-edit.select-calender-first" class="noCalendarSelected">Select a calendar first</div>-->
                    <!--                            </div>-->
                    <!--                        }-->

                </ng-template>
                <ng-template let-cat pTemplate="item">
                    <div class="flex justify-content-center">
                        <p-tag [value]="cat.title" [style]="{'background-color':cat.color}"
                            class="mr-2 unselectedCategory">
                        </p-tag>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>

        <div class="col-12 md:col-6 xl:col-3 subtitleField">
            <label i18n="@@appointment-management-edit.label.subTitle" for="subTitle"
                class="font-medium">Subtitle</label>
            <input pInputText id="subTitle" type="text" class="inputfield w-full" formControlName="subTitle">
        </div>

        <div class="col-12 descriptionField">
            <label i18n="@@appointment-management-edit.label.description" for="description" id="descriptionLabel"
                class="font-medium">Description</label>
            @if (editorLoaded){
                <editor id="description" class="block w-full" formControlName="description" [init]="tinyMceConfig"></editor>
            }

        </div>
        <div class="col-12 md:col-6 lg:col-6 locationField">
            <label i18n="@@appointment-management-edit.label.location" class="font-medium" id="locationLabel"
                for="location">Location</label>
            <div class="flex justify-content-between gap-2">
                <p-select id="location" inputId="location" [options]="allLocations" formControlName="locationId" optionValue="id" [filter]="true" filterBy="title"
                    optionLabel="title" placeholder="Select location" [showClear]="true" [autoDisplayFirst]="false"
                    [style]="{'width': '100%'}" i18n-placeholder="@@appointment-management-edit.placeholder.location">
                    <ng-template let-item #item>
                        <div class="white-space-normal">{{item.title}}</div>
                    </ng-template>
                </p-select>

                @if(hasLocationCreate()){
                    <p-button icon="fas fa-plus" severity="secondary" ariaLabel="Create new Location"
                              i18n-ariaLabel="@@appointment-management-edit.location.createLocation.label" (onClick)="createNewLocation()"></p-button>
                }
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-6 detailLinkField">
            <label i18n="@@appointment-management-edit.label.detailLink" class="font-medium" for="detailLink"
                aria-describedby="FirstnameError">Detail
                (Link)</label>
            <input pInputText id="detailLink" type="text" class="inputfield w-full mb-2" formControlName="detailLink">
            <div class="errorText"
                *ngIf="appointmentForm.get('detailLink').invalid && (appointmentForm.get('detailLink').dirty || appointmentForm.get('detailLink').touched)">
                <small class="form-text p-error" i18n="@@appointment-management-edit.error.detailLink.invalidURL"
                    *ngIf="appointmentForm.get('detailLink').errors.pattern" id="validLinkError">Please enter a valid
                    URL</small>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6 bg-black-alpha-10 appointmentManagerField" *hasAnyClaim="'profile_read'">
            <label for="contact" i18n="@@appointment-management-edit.label.contact" class="font-medium" id="appointmentManagerLabel">Appointment
                manager</label>
            <div class="flex">
                <p-autoComplete id="contact" inputId="contact" [suggestions]="contactProfilesSearch" [showClear]="false"
                    (onKeyUp)="detectDeleteKeyPressed($event)" class="inputfield w-full" [minLength]="2"
                    (completeMethod)="searchContactUserProfile($event)" field="realname" [forceSelection]="true"
                    [ngModelOptions]="{standalone: true}" dataKey="id" [(ngModel)]="contactProfile"
                    (onSelect)="contactProfileSelected($event)" [style]="{'width':'100%'}" [delay]="200"
                    [inputStyle]="{'width':'100%', 'margin-top':'.25rem'}" (onClear)="contactProfileCleared($event)"
                    appendTo="body">
                </p-autoComplete>
                <button pButton icon="far fa-times" class="p-button-text p-button-secondary"
                    (click)="contactProfileCleared($event)" *ngIf="contactProfile"></button>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6 bg-black-alpha-10 appointmentManagerField"
            *ngIf="coreLibService.hasAnyClaims(['profile_read']) == false">
            <label i18n="@@appointment-management-edit.label.contact" class="font-medium">Appointment
                manager</label>
            <div class="flex managerFromDuplicate" *ngIf="parentAppointment?.contact">
                {{parentAppointment.contact.realname}}
            </div>
            <div class="flex userAsManager" *ngIf="parentAppointment == null && myUserProfile">
                {{myUserProfile.realname}}
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6 bg-black-alpha-10 sm:pt-3 md:pt-2 lg:pt-2 appointmentManagerGroupField"
            *hasAnyClaim="'group_list'">
            <label i18n="@@appointment-management-edit.label.group" class="font-medium">Appointment
                manager group</label>
            <div class="flex">
                <p-button class="p-button-text pt-1 addGroupButton" (onClick)="openContactGroupPicker($event)"
                    label="Choose group" [disabled]="appointmentManagerGroupDisabled"
                    i18n-label="@@appointment-management-edit.button.contactGroup" severity="secondary">
                </p-button>
                <div *ngIf="selectedGroup"
                    class="bg-white-alpha-50 flex-1 justify-content-center align-items-center ml-2 flex overflow-hidden mt-1 selectedManagerGroup">
                    <div>{{selectedGroup.name}} ({{selectedGroup.numberOfMembers}})</div>
                </div>

                <p-button class="ml-2 mt-1 removeGroupButton" styleClass="p-button-text p-button-secondary"
                    (click)="removeContactGroup()" icon="far fa-times" *ngIf="selectedGroup"></p-button>
            </div>
        </div>

        <div class="col-12 bg-black-alpha-10 pt-3 managerHintText">
            <!--            Warnhinweise für ausgewählte Teamverantwortliche-->
            @if(!selectedGroup){
            <p-message severity="secondary" styleClass="mb-3" aria-live="polite">
                <div i18n="@@appointment-management-edit.text.appointmentManager.noGroup">
                    Attention: Please keep in mind, with regard to data protection, that all appointment coordinators or
                    members of the appointment-responsible group can view all registrations and contact details related
                    to the appointment.
                </div>
            </p-message>
            } @else if (selectedGroup && selectedGroup.numberOfMembers > 10){
            <p-message severity="error"  styleClass="mb-3" aria-live="polite">
                <div i18n="@@appointment-management-edit.text.appointmentManager.largeGroup">
                    Attention: The selected group has <b>more than 10 members</b>. Please keep in mind, with regard to
                    data protection, that all members of the appointment-responsible group can <b>view all registrations
                        and contact details</b> related to the appointment
                </div>
            </p-message>
            } @else{
            <p-message severity="warn" styleClass="mb-3" aria-live="polite">
                <div i18n="@@appointment-management-edit.text.appointmentManager.smallGroup">
                    Attention: You have selected an appointment-responsible group. Please keep in mind, with regard to
                    data protection, that all members of the appointment-responsible group can view all registrations
                    and contact details related to the appointment.
                </div>
            </p-message>
            }
            <p i18n="@@appointment-management-edit.text.appointmentManager">Appointment managers and all members of an
                appointment manager group have the right to edit and delete appointments and to view registrations
                including contact details.</p>
        </div>

        <div class="flex flex-column justify-content-end col-12 bg-black-alpha-10 pt-3 notifyManagerField">
            <div class="field-checkbox">
                <p-checkbox id="notifyEventContactPersonOnSignUp" inputId="notifyEventContactPersonOnSignUp" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['notifyEventContactPersonOnSignUp'])">
                </p-checkbox>
                <label for="notifyEventContactPersonOnSignUp"
                    i18n="@@appointment-management-edit.label.notifyEventContactPersonOnSignUp">Inform the person
                    responsible for the appointment about new registrations</label>
            </div>
        </div>



        <div class="col-12"></div>
        <div class="col-12 md:col-6 lg:col-3 mr-6 startDateField">
            <label i18n="@@appointment-management-edit.label.dateStart" for="dateStart" class="font-medium">
                Start *</label>
            <div class="flex w-full">
                <div class="w-8 mr-1 dateField">
                    <input type="date" class="p-inputtext p-component w-full" placeholder="Datum" id="dateStart" inputId="dateStart"
                        formControlName="dateStart" (change)="onDateStartSelected($event.target['value'])">
                </div>
                <div class="ml-3 timeField">
                    <label for="timeStart"
                    i18n="@@appointment-management-edit.label.time" class="sr-only">Time</label>
                    <input type="time" class="p-inputtext p-component" placeholder="Uhrzeit" formControlName="timeStart"
                        *ngIf="appointmentForm.get('allDay').value == false && appointmentForm.get('dateStart').value"
                        step="300" (change)="onDateTimeStartSelected($event.target['value'])" id="timeStart" inputId="timeStart">
                </div>
            </div>
            <div class="errorText"
                *ngIf="appointmentForm.get('dateStart').invalid && (appointmentForm.get('dateStart').dirty || appointmentForm.get('dateStart').touched)">
                <small class="form-text p-error" i18n="@@appointment-management-edit.error.startdate.required"
                    *ngIf="appointmentForm.get('dateStart').errors.required">A start date is required</small>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3 endDateField">
            <label i18n="@@appointment-management-edit.label.dateEnd" for="dateEnd" class="font-medium">End *</label>
            <div class="flex w-full">
                <div class="w-8 mr-1 dateField">
                    <input type="date" class="p-inputtext p-component  w-full" placeholder="Datum"
                        formControlName="dateEnd" id="dateEnd">
                </div>
                <div class="ml-3 timeField">
                     <label for="timeEnd"
                    i18n="@@appointment-management-edit.label.time" class="sr-only">Time</label>
                    <input type="time" class="p-inputtext p-component" placeholder="Uhrzeit" formControlName="timeEnd"
                        *ngIf="appointmentForm.get('allDay').value == false && appointmentForm.get('dateEnd').value"
                        step="300" id="timeEnd" inputId="timeEnd">
                </div>
            </div>
            <div class="errorText"
                *ngIf="appointmentForm.get('dateEnd').invalid && (appointmentForm.get('dateEnd').dirty || appointmentForm.get('dateEnd').touched)">
                <small class="form-text p-error" i18n="@@appointment-management-edit.error.enddate.required"
                    *ngIf="appointmentForm.get('dateEnd').errors.required">An end date is required</small>
            </div>
        </div>
        <div i18n="@@appointment-management-edit.error.endbeforestart" class="col-12 form-text p-error errorText"
            *ngIf="appointmentForm.get('dateEnd').value!=null && appointmentForm.get('dateStart').value!=null && moment(appointmentForm.get('dateEnd').value).isBefore(moment(appointmentForm.get('dateStart').value))">
            The appointment should start before the end date.
        </div>
        <div class="col-12 allDayField">
            <div class="field-checkbox">
                <p-checkbox id="allDay" inputId="allDay" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['allDay'])"></p-checkbox>
                <label i18n="@@appointment-management-edit.label.entireDay" for="allDay">All day event</label>
            </div>
        </div>
        <ng-container *ngIf="!parentAppointment || parentAppointment.id==null">
            <div class="col-12 md:col-6 lg:col-3 mr-6 repeatEventField">

                <label i18n="@@appointment-management-edit.repeat-label" class="font-medium" id="repeatLabel"
                    for="appointmentInterval">Repeat
                    every</label>

                <div class="flex justify-content-start">
                    <div>
                        <ng-container
                            *ngIf="appointmentForm.get('cycle').value !=='ONCE' && appointmentForm.get('cycle').value !=='CUSTOM'">
                            <div class="mr-1 standardRepeat">
                                <p-inputNumber [showButtons]="false" id="appointmentInterval" mode="decimal"
                                    formControlName="appointmentInterval"></p-inputNumber>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="appointmentForm.get('cycle').value ==='CUSTOM'">
                            <div class="customRepeat">
                                <div class="ml-1 mr-1">
                                    <input pInputText id="rrule" type="text" class="inputfield w-full"
                                        formControlName="rrule" aria-describedby="FirstnameError">
                                </div>
                                <div class="errorText"
                                    *ngIf="appointmentForm.get('rrule').invalid && (appointmentForm.get('rrule').dirty || appointmentForm.get('rrule').touched)">
                                    <small class="form-text p-error"
                                        i18n="@@appointment-management-edit.error.rrule.invalid"
                                        *ngIf="appointmentForm.get('rrule').errors.rrule">Please enter a valid
                                        rule.</small>
                                </div>
                                <div class="text-xs ml-1 mr-1 mt-1 repeatHintText" id="repeatHintText"
                                    i18n="@@appointment-management.rrule">If these options
                                    are not sufficient, you can generate custom rules on an external rrule website like
                                    <a href="https://freetools.textmagic.com/rrule-generator" target="_blank"
                                        class="text-primary" tabindex="0">Textmagic</a>
                                    and transfer the generated rule.
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="repeatTimeframe">
                        <p-select id="cycle" inputId="cycle" [options]="FORM_CYCLE_OPTIONS" optionValue="id" optionLabel="label"
                            dataKey="id" formControlName="cycle" placeholder="Select cycle"
                            (onChange)="onCycleChanged($event)"
                            i18n-placeholder="@@appointment-management-edit.cycle.placerholder">
                        </p-select>
                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-4 m-0 p-0 repeatWeekdays"
                    *ngIf="appointmentForm.get('cycle').value === 'WEEKS'">

                    <div class="p-field-checkbox mt-3">
                        <p-checkbox name="weekDays" value=0 id="rruleMO" inputId="rruleMO"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label i18n="@@appointment-management-edit.weekdays.Monday" for="rruleMO"
                            class="pl-2">Monday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=1 id="rruleTU" inputId="rruleTU"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label i18n="@@appointment-management-edit.weekdays.Tuesday" for="rruleTU"
                            class="pl-2">Tuesday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=2 id="rruleWE" inputId="rruleWE"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label for="rruleWE" i18n="@@appointment-management-edit.weekdays.Wednesday"
                            class="pl-2">Wednesday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=3 id="rruleTH" inputId="rruleTH"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label for="rruleTH" i18n="@@appointment-management-edit.weekdays.Thursday"
                            class="pl-2">Thursday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=4 id="rruleFR" inputId="rruleFR"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label for="rruleFR" i18n="@@appointment-management-edit.weekdays.Friday"
                            class="pl-2">Friday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=5 id="rruleSA" inputId="rruleSA"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label for="rruleSA" i18n="@@appointment-management-edit.weekdays.Saturday"
                            class="pl-2">Saturday</label>
                    </div>
                    <div class="p-field-checkbox mt-1">
                        <p-checkbox name="weekDays" value=6 id="rruleSU" inputId="rruleSU"
                            [formControl]="$any(appointmentForm.controls['appointmentWeekday'])"></p-checkbox>
                        <label for="rruleSU" i18n="@@appointment-management-edit.weekdays.Sunday"
                            class="pl-2">Sunday</label>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 repeatEnd" *ngIf="appointmentForm.get('cycle').value !=='ONCE'">
                <label i18n="@@appointment-management-edit.repeat-end" class="font-medium">Ends</label>


                <div class="flex">
                    <div>
                        <div class="field-radiobutton mt-2 endDate">
                            <p-radioButton id="appointmentEndTypeEndDate" inputId="appointmentEndTypeEndDate" name="appointmentEndType" value="endDate"
                                formControlName="appointmentEndType"></p-radioButton>
                            <label for="appointmentEndTypeEndDate"
                                i18n="@@appointment-management-edit.end-type.date">Date</label>
                        </div>
                        <div class="field-radiobutton endAmount">
                            <p-radioButton id="appointmentEndType" inputId="appointmentEndType" name="appointmentEndType" value="repeats" id="appointmentEndTypeRepeats"
                                formControlName="appointmentEndType"></p-radioButton>
                            <label for="appointmentEndTypeRepeats"
                                i18n="@@appointment-management-edit.end-type.repeats">Repeats</label>
                        </div>
                    </div>

                    <div class="ml-3 align-self-top repeatEndInput"
                        [class.align-self-top]="appointmentForm.get('appointmentEndType').value ==='endDate'"
                        [class.align-self-end]="appointmentForm.get('appointmentEndType').value ==='repeats'">
                        <input type="date" class="p-inputtext p-component" placeholder="Ends on"
                            i18n-placeholder="@@appointment-management-edit.cycle.enddate-placeholder"
                            formControlName="appointmentEndAtDate"
                            *ngIf="appointmentForm.get('appointmentEndType').value ==='endDate'" ariaLabelledBy="appointmentEndTypeEndDate">

                        <p-inputNumber [showButtons]="false" id="appointmentCount" class="mb-2"
                            *ngIf="appointmentForm.get('appointmentEndType').value ==='repeats'" mode="decimal"
                            formControlName="appointmentCount" ariaLabelledBy="appointmentEndTypeRepeats"></p-inputNumber>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="col-12"></div>

        <div class="col-12 md:col-6 thumbnailField">
            <label i18n="@@appointment-management-edit.button-thumbnail"
                class="font-medium pb-2">Thumbnail</label>
            <div id="thumbnail" class="formImage bg-primary-reverse border-dashed border-600 border-1 border-round mt-2"
                (click)="onSelectImages('icon')">
                <div *ngIf="appointmentForm.get('iconImage').value"
                    class="flex flex-column justify-content-center h-full">
                    <div class="relative h-full flex flex-column justify-content-center">
                        {{appointmentForm.get('iconImage').value}}
                        <!--TODO: Alternativtext / Titel der Ressource hinzufügen (wenn vorhanden / möglich)-->
                        <img [src]="appointmentForm.get('iconImage').value.url" [alt]="appointmentForm.get('iconImage').value.url">
                        <p-button icon="far fa-times" class="trashButton" [rounded]="true"
                            (click)="$event.stopPropagation();deletePreviewImage()" severity="secondary"
                            ariaLabel="Don't upload this image or video"
                            i18n-ariaLabel="@@appointment-management-edit.deleteThumbnail">
                        </p-button>
                    </div>
                </div>
                <div *ngIf="!appointmentForm.get('iconImage').value"
                    class="flex flex-column justify-content-center align-items-center h-full noImage">
                    <div class="relative flex flex-column justify-content-center align-items-center text-xl">
                        <i class="far fa-images text-600 text-6xl" aria-hidden="true"></i>
                        <div i18n="@@appointment-management-edit.image.text" class="text-600 pt-2">Click to add image
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 md:col-6 detailImagesField">
            <label i18n="@@appointment-management-edit.button-detail-images" class="font-medium">Detail
                images</label>
            <div id="resources"
                class="formImage bg-primary-reverse border-dashed border-600 border-1 border-round mt-2">
                <div *ngIf="appointmentForm.get('resources').value && appointmentForm.get('resources').value.length"
                    class="flex flex-column justify-content-center h-full relative">
                    <p-carousel [value]="appointmentForm.get('resources').value" [numVisible]="1" [numScroll]="1"
                        (onPage)="setActivePage($event.page)" circular="false"
                        [showIndicators]="appointmentForm.get('resources').value.length == 1 ? false : true" id="resourceCarousel" [page]="activeCarouselIndex"
                        [showNavigators]="appointmentForm.get('resources').value.length == 1 ? false : true">
                        <ng-template let-image pTemplate="item">
                            <div class="relative">
                                <!--TODO: Alternativtext / Titel der Ressource hinzufügen (wenn vorhanden / möglich)-->
                                <p-image [preview]="false" [imageStyle]="{'max-width':'100%','max-height':'10rem'}"
                                    [src]="image.url" [alt]="image.url">
                                </p-image>
                            </div>
                        </ng-template>
                    </p-carousel>
                    <p-button icon="far fa-times" class="trashButton" [rounded]="true" ariaLabel="Remove images" i18n-ariaLabel="@@appointment-management-edit.image.delete"
                        (click)="$event.stopPropagation();deleteContentImages()" severity="secondary">
                    </p-button>
                </div>
                <div *ngIf="!(appointmentForm.get('resources').value  && appointmentForm.get('resources').value.length)"
                    (click)="onSelectImages('resources')"
                    class="flex flex-column justify-content-center align-items-center h-full noImage">
                    <div class="relative flex flex-column justify-content-center align-items-center text-xl">
                        <i class="far fa-images text-600 text-6xl" aria-hidden="true"></i>
                        <div i18n="@@appointment-management-edit.image.text" class="text-600 pt-2">Click to add image
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 allowRegistrationField">
            <div class="field-checkbox mb-0">
                <p-checkbox id="registrationRequired" inputId="registrationRequired" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['registrationRequired'])"></p-checkbox>
                <label i18n="@@appointment-management-edit.label.registrationRequired" for="registrationRequired"
                    *doclink="'/modul-termin/#section-header-two-cgq3d'">Allow sign-ups</label>
            </div>
        </div>
        <div *ngIf="appointmentForm.controls['registrationRequired'].value === true"
            class="field bg-black-alpha-10 col-12 grid mb-2 registrationGrid">
            <div
                class="flex col-12 md:col-6 lg:col-6 xl:col-3 md:justify-content-start lg:justify-content-start justify-content-between flex-column column1">
                <div class="field flex md:justify-content-start justify-content-between maxParticipants">
                    <div class="flex-1">
                        <label for="availableAppointmentSlots" i18n="@@appointment-management-edit.label.numberOfSeats" id="availableSlotsLabel"
                            class="font-medium">Number
                            of seats available</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.numberOfSeats-helptext">
                            Leave
                            blank for unlimited seats</div>
                    </div>

                    <div class="ml-2 text-right">
                        <p-inputNumber [showButtons]="false" id="availableAppointmentSlots" mode="decimal"
                            buttonLayout="horizontal" formControlName="availableAppointmentSlots"></p-inputNumber>
                    </div>
                </div>
                <div class="field flex md:justify-content-start justify-content-between additionalSignups">
                    <div class="flex-1">
                        <label for="maxAdditionalSignUps" id="maxSignupsLabel"
                            i18n="@@appointment-management-edit.label.maxAdditionalSignups"
                            class="font-medium">Additional sign-ups</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.maxAdditionalSignups-helptext">
                            Number of allowed additional registrations per app user</div>
                    </div>

                    <div class="ml-2 text-right">
                         <p-inputNumber [showButtons]="false" buttonLayout="horizontal" id="maxAdditionalSignUps"
                            [style]="{'max-width':'10rem'}" class="ml-1" mode="decimal" [min]="0"
                            formControlName="maxAdditionalSignUps"></p-inputNumber>
                    </div>
                </div>

                <div class="field flex md:justify-content-start justify-content-between minParticipants">
                    <div class="flex-1">
                        <label for="minimumEventSignUps" i18n="@@appointment-management-edit.label.minimumSignUps" id="minSignupsLabel"
                            class="font-medium">Minimum number of participants</label>

                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.minimumRequirements-helptext">
                            Leave
                            blank for no minimum sign-up requirement</div>
                    </div>

                    <div class="ml-2 text-right">
                        <p-inputNumber [showButtons]="false" buttonLayout="horizontal" id="minimumEventSignUps" inputId="minimumEventSignUps"
                            [style]="{'max-width':'10rem'}" class="ml-1" mode="decimal"
                            formControlName="minimumEventSignUps"></p-inputNumber>
                    </div>
                </div>
                <div class="field flex md:justify-content-start justify-content-between publicSignups">
                    <div class="flex-1">
                        <label for="publicRegistrationAllowed" i18n="@@appointment-management-edit.label.publicSignups"
                            class="font-medium">Public sign-ups</label>

                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.publicSignups-helptext">
                            Allow external participants without an app profile to take part in the event.
                        </div>
                    </div>

                    <div class="ml-2 text-right">
                        <p-checkbox id="publicRegistrationAllowed" inputId="publicRegistrationAllowed" [binary]="true"
                            formControlName="publicRegistrationAllowed">
                        </p-checkbox>
                    </div>
                </div>
            </div>

            <div
                class="field flex col-12 md:col-6 lg:col-6 xl:col-3 md:justify-content-start lg:justify-content-start justify-content-between flex-column column2">
                <div class="flex flex-column mb-1 signupStart">
                    <div>
                        <label for="startOfRegistrationOffsetMinutes" id="registrationStartLabel"
                            i18n="@@appointment-management-edit.label.startOfRegistrationOffsetMinutes"
                            class="font-medium">Start date for registration</label>
                    </div>

                    <div class="text-xs my-1 hintText"
                        i18n="@@appointment-management-edit.label.startOfRegistrationOffsetMinutes-helptext">
                        Starting on this date, registrations will be allowed for the appointment.
                    </div>

                    <div class="text-right flex-1 mt-1 mb-4">
                        <div class="flex flex-column justify-content-end">
                            <lib-date-time-native-html5-picker formControlName="startOfRegistration"
                                (change)="onStartOfRegistrationChanged()"
                                id="startOfRegistrationOffsetMinutes"></lib-date-time-native-html5-picker>
                            <p-button label="Reset"
                                i18n-label="@@appointment-management-edit.label.startOfRegistrationReset"
                                *ngIf="appointmentForm.get('startOfRegistration').value !=null" [text]="true"
                                styleClass="pr-0" (onClick)="resetStartOfRegistration()" severity="danger"></p-button>
                        </div>
                    </div>
                </div>


                <div class="flex flex-column mb-1 signupEnd">
                    <div>
                        <label for="deadlineStartOffsetMinutes" id="registrationDeadlineLabel"
                            i18n="@@appointment-management-edit.label.deadlineStartOffsetMinutes"
                            class="font-medium">Registration deadline</label>
                    </div>

                    <div class="text-xs my-1 hintText" i18n="@@appointment-management-edit.label.deadline-helptext">
                        Registrations
                        are possible until the deadline. If not specified, registration is possible until the start of
                        the
                        appointment.
                    </div>

                    <div class="text-right flex-1 mt-1 mb-4">
                        <div class="flex flex-column justify-content-end">
                            <lib-date-time-native-html5-picker formControlName="deadline" (change)="onDeadLineChanged()"
                                id="deadlineStartOffsetMinutes"></lib-date-time-native-html5-picker>
                            <p-button label="Reset" i18n-label="@@appointment-management-edit.label.deadlineReset"
                                *ngIf="appointmentForm.get('deadline').value !=null" styleClass="pr-0" [text]="true"
                                (onClick)="resetDeadline()" severity="danger"></p-button>
                        </div>
                    </div>
                </div>

                <div class="flex flex-column cancelationEnd">
                    <div>
                        <label for="cancelRegistrationDeadlineOffsetMinutes" id="cancelationOffsetLabel"
                            i18n="@@appointment-management-edit.label.cancelRegistrationDeadlineOffsetMinutes"
                            class="font-medium">Cancellation deadline</label>
                    </div>

                    <div class="text-xs my-1 hintText"
                        i18n="@@appointment-management-edit.label.cancelation-deadline-helptext">
                        Cancellations are possible until the deadline. If not defined, cancellations are possible until
                        the
                        start of the appointment.
                    </div>

                    <div class="text-right flex-1 mt-1 mb-4">
                        <div class="flex flex-column justify-content-end">
                            <lib-date-time-native-html5-picker formControlName="cancelRegistrationDeadline"
                                (change)="onCancelationDeadLineChanged()"
                                id="cancelRegistrationDeadlineOffsetMinutes"></lib-date-time-native-html5-picker>
                            <p-button label="Reset" i18n-label="@@appointment-management-edit.label.deadlineReset"
                                *ngIf="appointmentForm.get('cancelRegistrationDeadline').value !=null" [text]="true"
                                styleClass="pr-0" (onClick)="resetCancelationDeadline()" severity="danger"></p-button>
                        </div>
                    </div>
                </div>

            </div>
            <div
                class="flex col-12 md:col-6 lg:col-6 xl:col-3 md:justify-content-start lg:justify-content-start justify-content-between flex-column column3">
                <div class="field flex md:justify-content-start justify-content-between">
                    <div class="grid flex-1 AttendanceDocumentation" style="margin-top: 0px">
                        <div class="col-8">
                            <label for="manageAttendees"
                                i18n="@@appointment-management-edit.label.attendees.manageAttendees"
                                class="font-medium">Attendance documentation</label>
                            <div class="text-xs mt-1 hintText"
                                i18n="@@appointment-management-edit.label.attendees.manageAttendees-helptext">
                                Use this feature to keep a list of attendees for documentation</div>
                        </div>
                        <div class="col-4 text-right">
                            <p-checkbox id="manageAttendees" inputId="manageAttendees" [binary]="true"
                                [formControl]="$any(appointmentForm.controls['manageAttendees'])">
                            </p-checkbox>
                        </div>
                        <ng-container *ngIf="appointmentForm.controls['manageAttendees'].value == true">
                            <div class="field flex flex-row qrTicket">
                                <div class="col-8 mt-5">
                                    <label for="issueTicketsUponRegistration"
                                        i18n="@@appointment-management-edit.label.attendees.issueTicketsUponRegistration"
                                        class="font-medium mt-1">Send QR code ticket</label>
                                    <div class="text-xs mt-1 hintText"
                                        i18n="@@appointment-management-edit.label.attendees.issueTicketsUponRegistration-helptext">
                                        Send QR code tickets to participants. These can be scanned by appointment
                                        managers
                                        to confirm participation.
                                    </div>
                                </div>
                                <div class="col-4 mt-5 text-right">
                                    <p-checkbox id="issueTicketsUponRegistration" inputId="issueTicketsUponRegistration" [binary]="true" class="mt-1"
                                        [formControl]="$any(appointmentForm.controls['issueTicketsUponRegistration'])">
                                    </p-checkbox>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div
                    class="field flex flex-column md:justify-content-start justify-content-between participantVisibility">
                    <div class="flex-1">
                        <label for="visibleMemberList" i18n="@@appointment-management-edit.label.visibleMemberList" id="memberListLabel"
                            class="font-medium">Visibility of participant list</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.memberListVisibility-helptext">
                            Defines which users can see the list of participants.
                        </div>
                    </div>
                    <div class="mt-2">
                        <p-select id="visibleMemberList" inputId="visibleMemberList" [options]="MEMBER_LIST_VISIBILITIES"
                            formControlName="memberListVisibility" optionValue="id" optionLabel="label"
                            placeholder="Select visibility" appendTo="body" [autoDisplayFirst]="true"
                            [style]="{'width':'100%'}"
                            i18n-placeholder="@@appointment-management-edit.label.memberlist-visibility-placeholder">
                        </p-select>
                    </div>
                </div>
                <div class="field flex md:justify-content-start justify-content-between waitingList">
                    <div class="grid flex-1" style="margin-top: 0px">
                        <div class="col-8">
                            <label for="waitingListEnabled"
                                i18n="@@appointment-management-edit.label.attendees.waitingListEnabled"
                                class="font-medium">Waiting list</label>
                            <div class="text-xs mt-1 hintText"
                                i18n="@@appointment-management-edit.label.attendees.waitingListEnabled-helptext">
                                Once all available places have been reserved, you can be placed on the waiting list. The
                                system will then inform you when a space is available again.</div>
                        </div>
                        <div class="col-4 text-right">
                            <p-checkbox id="waitingListEnabled" inputId="waitingListEnabled" [binary]="true"
                                [formControl]="$any(appointmentForm.controls['waitingListEnabled'])">
                            </p-checkbox>
                        </div>
                    </div>
                </div>
                <div class="field flex md:justify-content-start justify-content-between maxReservationTime"
                    *ngIf="appointmentForm.controls['waitingListEnabled'].value == true">
                    <div class="grid flex-1" style="margin-top: 0px">
                        <div class="col-8">
                            <label for="maxReservationTime" id="reservationTimeLabel"
                                i18n="@@appointment-management-edit.label.attendees.maxReservationTime"
                                class="font-medium">Maximal reservation time</label>
                            <div class="text-xs mt-1 hintText"
                                i18n="@@appointment-management-edit.label.attendees.maxReservationTime-helptext">
                                Maximum reservation duration in minutes. This setting is relevant for the waitlist and
                                defines the maximum time a spot remains reserved before being passed on to the next
                                person on the waitlist.</div>
                        </div>
                        <div class="col-4 text-right">
                            <p-inputNumber [showButtons]="false" buttonLayout="horizontal" id="maxReservationTime"
                                [style]="{'max-width':'10rem'}" class="ml-1" mode="decimal" [min]="10"
                                formControlName="maxReservationTime"></p-inputNumber>
                        </div>
                    </div>
                </div>

            </div>
            <div
                class="field flex col-12 md:col-6 lg:col-6 xl:col-3 md:justify-content-start lg:justify-content-start justify-content-between flex-column column4">
                <div class="flex md:justify-content-start justify-content-between pushReminder"
                    formGroupName="reminder">
                    <div class="field flex flex-1 flex-column">
                        <div class="flex flex-row justify-content-between align-items-center activateReminder">
                            <label for="reminder" i18n="appointment-management-edit.label.reminder"
                                class="font-medium">Reminder</label>
                            <div class="ml-2">
                                <p-checkbox [binary]="true" id="reminder" inputId="reminder"
                                    [formControl]="appointmentForm.get('reminder')['controls']['active']"
                                    labelStyleClass="font-medium">
                                </p-checkbox>
                            </div>
                        </div>

                        <div class="mt-2" *ngIf="appointmentForm.get('reminder')['controls']['active'].value == true">
                            <div class="reminderMessage">
                                <label i18n="@@appointment-management-edit.label.reminder-message" for="availableAppointmentSlots"
                                    class="font-medium sr-only">Push message</label>
                                <textarea pInputTextarea class="block w-full" rows="3"
                                    formControlName="message" id="availableAppointmentSlots" inputId="availableAppointmentSlots"></textarea>
                            </div>
                            <div class="mb-0 mt-1 flex justify-content-between reminderTime">
                                <label for="availableAppointmentSlots" id="availableSlotsLabel"
                                    i18n="@@appointment-management-edit.label.reminder-value"
                                    class="font-medium mb-0 align-content-center">Hours until event</label>
                                <p-inputNumber [showButtons]="false" buttonLayout="horizontal"
                                    [style]="{'max-width':'10rem'}" class="ml-1" mode="decimal" [min]="0"
                                    formControlName="value" id="availableAppointmentSlots"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="field flex md:justify-content-start justify-content-between payment">
                    <div class="flex-1">
                        <label for="paymentDocumentation"
                            i18n="@@appointment-management-edit.label.paymentDocumentation" class="font-medium">Payment
                            documentation</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.paymentDocumentation-helptext">
                            Allows documentation of payments made by the participants.</div>
                    </div>
                    <div class="ml-2 text-right">
                        <p-checkbox id="paymentDocumentation" inputId="paymentDocumentation" [binary]="true"
                            [formControl]="$any(appointmentForm.controls['paymentDocumentation'])">
                        </p-checkbox>
                    </div>
                </div>
                <div class="field flex flex-column md:justify-content-start justify-content-between useForm">
                    <div class="flex-1">
                        <label for="registationForm" i18n="@@appointment-management-edit.label.registrationForm" id="registrationFormLabel"
                            class="font-medium">Registration form</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.registration-form-helptext">
                            Use an extended form which the user must fill out when registering for an appointment.
                        </div>
                    </div>
                    <div class="mt-2">
                        <p-select id="registationForm" inputId="registationForm" [options]="registrationForms"
                            formControlName="registrationFormId" optionValue="id" optionLabel="name"
                            placeholder="No Form" appendTo="body" [autoDisplayFirst]="true" [showClear]="true"
                            [style]="{'width':'100%'}"
                            i18n-placeholder="@@appointment-management-edit.label.registration-form-no-placeholder">
                        </p-select>
                    </div>
                </div>

                <div class="field flex flex-column justify-content-start justify-content-between payment">
                    <div class="flex-1">
                        <label for="productIds" i18n="@@appointment-management-edit.label.paid-appointment" id="paymentLabel"
                            class="font-medium" *doclink="'/bezahlfunktion'">Paid appointment</label>
                        <div class="text-xs mt-1 hintText"
                            i18n="@@appointment-management-edit.label.paid-appointment-helptext">
                            Please select one or more products with which the app user can take part in this event here.
                        </div>
                    </div>
                    <p-multiSelect [options]="products" optionLabel="name" optionValue="id" id="productIds" inputId="productIds"
                        [disabled]="!productsEnabled" formControlName="productIds" [style]="{'width': '100%'}"
                        appendTo="body">
                        <ng-template let-value pTemplate="selectedItems">
                            <div *ngFor="let product of value">
                                <div class="flex align-items-center gap-2 selectedProduct">
                                    <img [src]="product.image?.url" style="width: 25px" />
                                    <div class="ml-1">{{ product.name }}</div>
                                    <div class="ml-1" *ngIf="product.paymentProviderReference!=null">
                                        <p-tag severity="success" value="Productive system"
                                            i18n-value="@@payment-products-table-system.prod"
                                            *ngIf="product.paymentProviderReference.environment === 'PROD'"
                                            styleClass="ml-2 text-xs"></p-tag>
                                        <p-tag severity="info" value="Test system "
                                            i18n-value="@@payment-products-table-status.system.test"
                                            *ngIf="product.paymentProviderReference.environment === 'TEST'"
                                            styleClass="ml-2 text-xs"></p-tag>
                                        <p-tag severity="secondary" value="Archived"
                                            i18n-value="@@payment-products-table-status.system.archived"
                                            *ngIf="!product.active"
                                            styleClass="ml-2 text-xs"></p-tag>   
                                    </div>
                                </div>

                            </div>
                            <div *ngIf="!value || value.length === 0">&nbsp;</div>
                        </ng-template>
                        <ng-template let-product pTemplate="item">
                            <div class="flex align-items-center gap-2 unselectedProduct">
                                <img [src]="product.image?.url" style="width: 25px" />
                                <div class="ml-1">{{ product.name }}</div>
                                <ng-container *ngIf="product.paymentProviderReference!=null">
                                    <p-tag severity="success" value="Productive system"
                                        i18n-value="@@payment-products-table-system.prod"
                                        *ngIf="product.paymentProviderReference.environment === 'PROD'"
                                        styleClass="ml-2 text-xs"></p-tag>
                                    <p-tag severity="info" value="Test system "
                                        i18n-value="@@payment-products-table-status.system.test"
                                        *ngIf="product.paymentProviderReference.environment === 'TEST'"
                                        styleClass="ml-2 text-xs"></p-tag>
                                    <p-tag severity="secondary" value="Archived"
                                            i18n-value="@@payment-products-table-status.system.archived"
                                            *ngIf="!product.active"
                                            styleClass="ml-2 text-xs"></p-tag>   
                                </ng-container>
                            </div>
                        </ng-template>

                    </p-multiSelect>
                </div>


                <ng-container *ngIf="!parentAppointment || parentAppointment.id==null">
                    <div class="fieldflex flex-column justify-content-start justify-content-between groupRegistration"
                        *hasAnyClaim="'group_list'">
                        <label for="groupRegistration" i18n="@@appointment-management-edit.label.groupRegistration"
                            class="font-medium">Group registration</label>
                        <div class="text-xs mt-2 hintText"
                            i18n="@@appointment-management-edit.button.groupRegistration-helptext">All
                            current members of the group are automatically registered for the appointment.</div>
                        <div class="flex mt-1">
                            <p-button class="p-button-text pt-1 addGroupButton"
                                (onClick)="onOpenGroupRegistrationPicker($event)" label="Choose"
                                i18n-label="@@appointment-management-edit.button.groupRegistration"
                                severity="secondary">
                            </p-button>
                            <div *ngIf="selectedGroupRegistration"
                                class="bg-white-alpha-50 flex-1 justify-content-center align-items-center ml-2 flex overflow-hidden mt-1 selectedGroup">
                                <div>{{selectedGroupRegistration.name}}</div>
                            </div>
                            <p-button styleClass="ml-2 mt-1 p-button-text p-button-secondary removeGroupButton"
                                (click)="onRemoveGroupRegistration()" icon="far fa-times" ariaLabel="remove Group" i18n-ariaLabel="@@appointment-management-edit.removeGroup"
                                *ngIf="selectedGroupRegistration"></p-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="col-12">
            <div class="field-checkbox allowFeedbackField mb-0">
                <p-checkbox id="allowFeedback" inputId="allowFeedback" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['feedbackAllowed'])">
                </p-checkbox>
                <label i18n="@@appointment-management-edit.label.feedbackAllowed" aria-hidden="true"
                    *doclink="'/modul-termin/#section-header-two-8kdo9'"
                    (click)="appointmentForm.controls['feedbackAllowed'].setValue(!appointmentForm.get('feedbackAllowed').value)">
                    Participation feedback (<i class="fa-light fa-thumbs-up"></i>&nbsp;<i
                        class="fa-light fa-question"></i>&nbsp;<i class="fa-light fa-thumbs-down"></i> - Function)

                </label>
                <label for="allowFeedback" i18n="@@appointment-management-edit.label.feedbackAllowedSROnly"
                    *doclink="'/modul-termin/#section-header-two-8kdo9'" class="sr-only"
                    (click)="appointmentForm.controls['feedbackAllowed'].setValue(!appointmentForm.get('feedbackAllowed').value)">
                    Participation feedback (Thumbs up, question mark or thumbs down - Function)

                </label>
            </div>
        </div>
        <div class="bg-black-alpha-10 col-12 pb-3 groupInvitation"
            *ngIf="(!parentAppointment || parentAppointment.id==null) && appointmentForm.controls['feedbackAllowed'].value == true">
            <div class="flex col-12 flex-column" *hasAnyClaim="'group_list'">
                <label for="groupInvitation" i18n="@@appointment-management-edit.label.groupInvitation"
                    class="font-medium">Group invitation</label>
                <div class="text-xs mt-2 hintText" i18n="@@appointment-management-edit.button.groupInvitation-helptext">
                    All current members of the group are automatically invited for the appointment and are requested to
                    provide feedback.</div>
                <div class="flex mt-2">
                    <p-button class="p-button-text pt-1 addGroupButton" (onClick)="onOpenGroupInvistationPicker($event)"
                        label="Choose" i18n-label="@@appointment-management-edit.button.groupInvitation"
                        severity="secondary">
                    </p-button>
                    <div *ngIf="selectedGroupInvitation"
                        class="bg-white-alpha-50 flex-1 justify-content-center align-items-center ml-2 flex overflow-hidden mt-1 selectedInviteGroup">
                        <div>{{selectedGroupInvitation.name}}</div>
                    </div>
                    <p-button styleClass="ml-2 mt-1 p-button-text p-button-secondary removeGroupButton"
                        (onClick)="onRemoveGroupInvitation()" icon="far fa-times"  ariaLabel="remove Group" i18n-ariaLabel="@@appointment-management-edit.removeGroup"
                        *ngIf="selectedGroupInvitation"></p-button>
                </div>
            </div>
        </div>

        <div class="col-12 conferenceField">
            <div class="field-checkbox">
                <p-checkbox id="onlineConference" inputId="onlineConference" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['onlineConference'])">
                </p-checkbox>
                <label for="onlineConference" i18n="@@appointment-management-edit.label.onlineConference">Online
                    Conference</label>
            </div>
            <div class="text-xs hintText" i18n="@@appointment-management-edit.label.onlineConference-helptext">Create an
                online
                conference with Appack-Meet</div>
        </div>

        <div class="col-12 mt-2 badgeField">
            <div class="field-checkbox">
                <p-checkbox id="badgeEnabled" inputId="badgeEnabled" [binary]="true"
                    [formControl]="$any(appointmentForm.controls['badgeEnabled'])">
                </p-checkbox>
                <label for="badgeEnabled" i18n="@@appointment-management-edit.label.badgeEnabled">Mark as new</label>

            </div>
            <div class="text-xs hintText" i18n="@@appointment-management-badgeEnabled-helptext">
                Highlight this appointment for app users so that it stands out immediately.</div>
        </div>

    </div>

    <div class="flex justify-content-between mt-4 buttonBox">
        <div>
            <p-button type="button" severity="secondary" class="mr-2 cancelButton" (click)="this.ref.close(null)"
                label="Cancel" i18n-label="@@appointment-management-edit.button.cancel"></p-button>
        </div>
        <div class="flex-1 text-right">
            <p-button *ngIf="parentAppointment?.id" type="button" severity="danger" class="mr-2 deleteButton"
                (click)="onDelete()" label="Delete" i18n-label="@@appointment-management-edit.button.delete"></p-button>
            <p-button type="button" severity="secondary" class="saveButton" (click)="onSubmit()" label="Save"
                i18n-label="@@appointment-management-edit.button.save"></p-button>
        </div>
    </div>

</form>
<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-list.confirm-series-edit"
    header="Edit Recurring Event" [(visible)]="dialogControl.showAppointmentSeriesEditConfirmDialog" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-edit.seriesEditDialog.Close" 
    (onShow)="onModalShow('seriesEditDialog')"
    *ngIf="dialogControl.showAppointmentSeriesEditConfirmDialog" [modal]="true" [draggable]="false"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}" id="seriesEditDialog">
    <div i18n="@@appointment-management-list.confirm-series-text" class="title">
        Which events should be changed?
    </div>
    <div class="flex flex-column changeType">
        <div>
            <p-radioButton class="mt-4" id="changeTypeSelected" inputId="changeTypeSelected" name="change-type" value="SELECTED"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeSelected" i18n="@@appointment-management-edit.edit-series-change-type.eventOnly">This
                Event</label>
        </div>
        <div>
            <p-radioButton class="mt-2" id="changeTypeSubsequent" inputId="changeTypeSubsequent" name="change-type" value="SUBSEQUENT"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeSubsequent"
                i18n="@@appointment-management-edit.edit-series-change-type.following">This and all following
                events</label>
        </div>
        <div>
            <p-radioButton class="mt-2" id="changeTypeAll" inputId="changeTypeAll" name="change-type" value="ALL"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeAll" i18n="@@appointment-management-edit.edit-series-change-type.event">All
                Events</label>
        </div>
    </div>

    <div class="flex justify-content-between mt-5 buttonBox">
        <p-button type="button" (click)="dialogControl.showAppointmentSeriesEditConfirmDialog = false" label="Cancel"
            severity="secondary" class="cancelButton"
            i18n-label="@@appointment-management-edit.button.cancel"></p-button>
        <p-button type="button" class="saveButton" (click)="onSeriesEditConfirmed(dialogControl.context.changeType)"
            label="Save" i18n-label="@@appointment-management-edit.button.save" severity="secondary"></p-button>
    </div>
</p-dialog>

<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-list.confirm-series-delete"
    header="Delete Recurring Event" [(visible)]="dialogControl.showAppointmentSeriesDeleteConfirmDialog"
    *ngIf="dialogControl.showAppointmentSeriesDeleteConfirmDialog" [modal]="true" [draggable]="false"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}" id="seriesDeleteDialog" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-edit.seriesDeleteDialog.Close" (onShow)="onModalShow('seriesDeleteDialog')">
    <div i18n="@@appointment-management-list.delete-confirm-series-text" class="mt-4 title">
        Which events should be changed?
    </div>
    <div class="flex flex-column changeType">
        <div>
            <p-radioButton class="mt-4" id="changeTypeSelected" inputId="changeTypeSelected" name="change-type" value="SELECTED"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeSelected" i18n="@@appointment-management-edit.edit-series-change-type.eventOnly">This
                Event</label>
        </div>
        <div>
            <p-radioButton class="mt-2" id="changeTypeSubsequent" inputId="changeTypeSubsequent" name="change-type" value="SUBSEQUENT"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeSubsequent"
                i18n="@@appointment-management-edit.edit-series-change-type.following">This and all following
                events</label>
        </div>
        <div>
            <p-radioButton class="mt-2" id="changeTypeAll" inputId="changeTypeAll" name="change-type" value="ALL"
                [(ngModel)]="dialogControl.context.changeType"></p-radioButton>
            <label for="changeTypeAll" i18n="@@appointment-management-edit.edit-series-change-type.event">All
                Events</label>
        </div>
    </div>
    <div class="flex justify-content-between mt-4 buttonBox">
        <p-button type="button" (click)="dialogControl.showAppointmentSeriesDeleteConfirmDialog = false" label="Cancel"
            severity="secondary" class="cancelButton"
            i18n-label="@@appointment-management-edit.button.cancel"></p-button>
        <p-button type="button" severity="danger" (click)="onDeleteEvent(dialogControl.context.changeType)"
            label="Delete" class="deleteButton" i18n-label="@@appointment-management-edit.button.delete"></p-button>
    </div>
</p-dialog>

<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-edit.media-library-select-source.header"
    header="Select image source" [(visible)]="dialogControl.showImageSourceDialog" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-edit.mediaLibraryDialog.Close" 
     (onShow)="onModalShow('mediaLibraryDialog')"
    *ngIf="dialogControl.showImageSourceDialog" [modal]="true" [draggable]="false"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}" id="mediaLibraryDialog">
    <div class="flex flex-column align-items-center w-full surface-border">
        <p i18n="@@appointment-management-edit.media-library-select-source-text">From which source do you want to select
            the image ?</p>
    </div>

    <div class="flex mt-4 buttonBox" [class.justify-content-between]="hasProfile()"
        [class.justify-content-center]="!hasProfile()">
        <p-button label="Media library" i18n-label="@@appointment-management-edit.source.media-library"
            class="mediaLibButton" (onClick)="onSelectImagesFromMediaLibrary(dialogControl.context)"
            severity="secondary"></p-button>
        <p-button label="Personal file storage" i18n-label="@@appointment-management-edit.source.personal-file-storage"
            *ngIf="hasProfile()" class="filestoreButton" (onClick)="onSelectImagesFromFileStore(dialogControl.context)"
            severity="secondary"></p-button>
    </div>
</p-dialog>
